import { render, staticRenderFns } from "./AllArticle.vue?vue&type=template&id=2f2775cb&scoped=true&"
import script from "./AllArticle.vue?vue&type=script&lang=js&"
export * from "./AllArticle.vue?vue&type=script&lang=js&"
import style0 from "./AllArticle.vue?vue&type=style&index=0&id=2f2775cb&prod&lang=scss&scoped=true&"
import style1 from "./AllArticle.vue?vue&type=style&index=1&id=2f2775cb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2775cb",
  null
  
)

export default component.exports